// extracted by mini-css-extract-plugin
export default {"container":"PatientStatus_container__iE134","micIcon":"PatientStatus_micIcon__v2LJI","videoIcon":"PatientStatus_videoIcon__qaMTV","updateHint":"PatientStatus_updateHint__vxSWg"};